import { ADD_NEW_BOOK, EDIT_BOOK, LOAD_BOOKS, OPEN_EDIT_MODE, REMOVE_BOOK } from "./actionTypes"

const initialState = {
    books: [],
    editMode: {
        status: false,
        bookData: {}
    }
}

const productReducer = (state=initialState, action) => {
    switch (action.type) {
        case LOAD_BOOKS:
            return {
                ...state,
                books: action.payload
            }
            
        case ADD_NEW_BOOK:
            return {
                ...state,
                books: [...state.books, action.payload]
            }
        
        case REMOVE_BOOK:
            return {
                ...state,
                books: state.books.filter((book) => book.id !== action.payload)
            }
        
        case OPEN_EDIT_MODE:
            return {
                ...state,
                editMode: {
                    status: true,
                    bookData: action.payload
                }
            }
        
        case EDIT_BOOK:
            return {
                ...state,
                books: state.books.map((book) => {
                    if(book.id !== action.payload.id){
                        return book;
                    }else{
                        return {
                            ...action.payload
                        }
                    }
                }),
                editMode: {
                    status: false,
                    bookData: {}
                }
            }
    
        default:
            return state
            
    }
}


export default productReducer